module.exports = __webpack_public_path__ + "img/seminar-1995.fbbb413b.jpg";